<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>出版准备检查</span>
                        <h1>做好手稿的出版准备</h1>
                        <p>根据20多种标准出版要求评估您的手稿，以更快地通过期刊筛选。Trinka甚至可以让您查看手稿与目标期刊出版范围的匹配程度。</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=CN" id="autoEditGetStart" target="_blank">开始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <!-- <div class="trinka_cloud_banner_img">
                        <img src="assets/images/PublicationReadinessChecksImg.png" alt="">
                    </div> -->
                    <div class="toolbox_img_content publication_checks_icons publication_checks_section">
                        <!-- <img src="assets/images/PublicationReadinessChecksImg.png" alt=""> -->
                        <ul>
                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/JournalScope.svg" alt="">
                                </div>
                                <h3>期刊范围匹配</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/TechnicalCompliance.svg" alt="">
                                </div>
                                <h3>技术合规</h3>
                                <span>3 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/EthicalCompliance.svg" alt="">
                                </div>
                                <h3>道德合规</h3>
                                <span>5 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/AuthorshipDetails.svg" alt="">
                                </div>
                                <h3>作者详细信息</h3>
                                <span>4 Checks</span>
                            </li>
                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/ReferenceDetails.svg" alt="">
                                </div>
                                <h3>参考文献的细节</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/FirgureTable.svg" alt="">
                                </div>
                                <h3>图表</h3>
                                <span>2 Checks</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/ClinicalTrials.svg" alt="">
                                </div>
                                <h3>临床试验信息</h3>
                                <span>1 Check</span>
                            </li>

                            <li>
                                <div class="checks_icons">
                                    <img src="assets/images/KeywordsAndSummary.svg" alt="">
                                </div>
                                <h3>关键字和摘要</h3>
                                <span>2 Checks</span>
                            </li>
                            <i></i>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>工作原理</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/RegisterAndLogin.png" alt="" style="    width: 46px;  height: 45px;">
                                </div>
                                <h3>注册 /
                                    <br /> 登录</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/TypeOrImportFile_icon.png" alt="" style="width: 36px; height: 45px;">
                                </div>
                                <h3>打开/导入文件并选择
                                    <br />发表准备情况检查</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="assets/images/improveYourWriting_icon.png" alt="" style="    width: 36px;  height: 46px;">
                                </div>
                                <h3>获取详细的评估报告</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="SectionHowItWrok" #viewVideo>
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/PublicationCheckThumbnail.png" alt="" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何工作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">通过这个简短的演练视频，了解如何使用20多项出版准备检查并更快地实现出版目标。</p>
                        <p style="margin-bottom: 10px;">这个详细的分步教程可帮助您充分利用Trinka的强大功能。如果您有更多问题，请在
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link remove-space">此处</a>浏览我们的常见问题解答。</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>出版准备检查的主要特征</h2>
                        <div class="HeadingSubLine"></div>
                        <p>使用Trinka的出版准备检查，您可以通过为出版物准备的20多项检查来评估您的文档，并进行修订以增加发表的机会。</p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="assets/images/JournalScope.svg" alt="">
                        </div>
                        <h3>期刊范围匹配</h3>
                        <p>通过检查您的稿件是否与目标期刊的范围相匹配并为您推荐其他匹配的期刊，避免稿件被拒。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="assets/images/TechnicalCompliance.svg" alt="">
                        </div>
                        <h3>技术合规</h3>
                        <p>Trinka会检查几种标准的出版物要求，例如摘要、字数和原稿章节标题，以确保您的手稿满足期刊的所有要求。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="publication_inner_icons">
                            <img src="assets/images/EthicalCompliance.svg" alt="">
                        </div>
                        <h3>道德合规</h3>
                        <p>确保您已进行所有强制性声明，例如知情同意、道德批准、财务披露和利益冲突，以便顺利进行编辑审查。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="assets/images/AuthorshipDetails.svg" alt="">
                        </div>
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>作者详细信息</h3>
                        <p>检查大多数期刊所要求的作者详细信息，例如作者姓名、隶属关系，通信信息和作者贡献声明等等。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="assets/images/ReferenceDetails.svg" alt="" style="width: 30px; height: 38px;">
                        </div>
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>参考文献的细节</h3>
                        <p>Trinka会检查您的参考文献并提醒您是否使用了过时的参考文献。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="assets/images/FirgureTable.svg" alt="">
                        </div>
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>图表</h3>
                        <p>Trinka会检查您所有的图形标题、表格标题及其引用，以确保满足所有的投稿要求。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="assets/images/ClinicalTrials.svg" alt="" style="width: 29px; height: 35px;">
                        </div>
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>临床试验信息</h3>
                        <p>Trinka会检查您是否提到了任何临床试验ID，并获取有关试验的信息，以便您始终可以确保提供正确的详细信息。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <div class="publication_inner_icons">
                            <img src="assets/images/KeywordsAndSummary.svg" alt="">
                        </div>
                        <!-- <img src="assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>关键字和摘要</h3>
                        <p>Trinka的顶级人工智能可以为您的论文提供全面的、有代表性的总结，并突出论文的重要主题和概念，它还会为您的稿件建议可能的关键字。 </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>查看样本报告</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <!-- <div class="col-sm-2"></div> -->
                <div class="col-sm-12">
                    <div class="viewSampleReportImg">
                        <img src="assets/images/PublicationReportImg.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>检查您的手稿是否做好出版准备</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">开始使用</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>使用积分及进行出版准备检查</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        <div class="featurePointsCredits">
                            <span>
                                <img src="assets/images/lightbulb.png" alt="">
                            </span>
                            <p>每个检查报告将花费1个积分。使用免费积分并根据需要购买更多。</p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 10px;">积分就像代币一样，可让您根据需要使用多种Trinka功能。</p>
                            <p>高级用户每月获得10个积分，基本用户每月获得4个免费积分。要了解更多信息，请单击
                                <a [routerLink]="['/features/credits']" class="remove-space">此处。</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常见问题</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        出版准备检查会消耗多少积分？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>每次运行出版准备检查都会消耗1个积分。 </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        我可以下载出版准备检查报告吗？ </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前您无法下载出版准备检查报告，但是您的报告在Trinka云上始终可见。您注册的电子邮件也会收到每个检查报告的链接。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我能在Trinka的基本计划中获得出版准备检查功能吗？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，这项功能将消耗积分。基本订阅用户每月将获得4个免费积分，可用于获取出版准备检查报告。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        如何使用出版准备检查报告？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以将出版准备检查报告作为投稿清单，轻松地与目标期刊的要求进行比较，并且轻松评估手稿的准备情况。我们也准备了一个
                                            <a style="color: #0000ff;" (click)="scroll(viewVideo)" class="link remove-space">视频</a>来帮助您理解报告。</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        使用Trinka出版准备检查功能来提高您的出版机会
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>从期刊选择到道德合规等20多个检查标准来评估您的文档，帮助您提高出版的机会。</p>
                                    </div>
                                </div>
                            </div> -->

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Others_App_MSWord.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span>
                                                <br />插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/other_Apps_browser.svg" alt="">
                                            <h3>浏览器插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                            <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                            <span class="OpenSansFonts" style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="//player.bilibili.com/player.html?aid=813584624&bvid=BV1y34y1J7VB&cid=776610999&page=1"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>